const s=(e,...t)=>!e||!e.length||e.some(o=>typeof o!="function")?(console.warn(`${e} is expected to be a function array`),{}):e.reduce((o,c)=>Object.assign(o,c(...t)),{});export{s as combineMappers};
//# sourceMappingURL=combineMappers.js.map
